if (!customElements.get("ld-partner-carousel")) {
  customElements.define(
    "ld-partner-carousel",
    class LdPartnerCarousel extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth <= 768;
      }

      startTransformScroll(container, speed = 0.5) {
        const inner = container.querySelector(".swiper-wrapper");
        let paused = false;
        let offset = 0;
        const step = () => {
          if (!paused) {
            offset -= speed;
            const first = inner.children[0];
            const firstWidth = first.offsetWidth;
            // 如果第一个元素完全移出视口左侧
            if (-offset >= firstWidth) {
              // 调整偏移量并移动第一个元素到最后
              offset += firstWidth;
              inner.appendChild(first);
            }
            inner.style.transform = `translateX(${offset}px)`;
          }
          requestAnimationFrame(step);
        };
        container.addEventListener("mouseenter", () => (paused = true));
        container.addEventListener("mouseleave", () => (paused = false));
        requestAnimationFrame(step);
      }

      initSwiperDesktop() {
        const wrapper = this.querySelector(".swiper");
        const slidesSize = wrapper.querySelectorAll(".swiper-slide").length;
        if (slidesSize <= 8) {
          return;
        }
        this.startTransformScroll(this, 1);
      }

      connectedCallback() {
        // window.addEventListener("onLoad", () => {
        this.initSwiperDesktop();
        // });
      }
    }
  );
}
